import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import { DragIndicator, Delete } from '@mui/icons-material';

export function SortableItem({ id, content, onDelete }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    marginBottom: '8px'
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Paper 
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: isDragging ? '#f5f5f5' : 'white',
          boxShadow: isDragging ? 3 : 1,
          '&:hover': { boxShadow: 2 }
        }}
        {...attributes}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <div {...listeners}>
            <DragIndicator sx={{ color: 'text.secondary', cursor: 'move' }} />
          </div>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ color: '#000', fontSize: '1rem', mb: 0.5 }}>
              {content.title}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', fontSize: '0.875rem' }}>
              {content.source_type}
            </Typography>
          </Box>
        </Box>
        <IconButton size="small" color="error" onClick={onDelete}>
          <Delete />
        </IconButton>
      </Paper>
    </div>
  );
}